
import { DataType } from "@dndModels/Types";
import { ModelBase } from "@models/UpsertableBase";

export class TemplateBase extends ModelBase {
  data_type: DataType = "template";
  type = "";
  category = "None";
  item: any = {};

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.type = obj.type ? `${obj.type}` : "";
      this.category = obj.category ? `${obj.category}` : "None";
      this.item = obj.item ? obj.item : {};
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.item = obj.item ? obj.item : {};
  //   }
  // }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      type: this.type,
      category: this.category,
      item: this.item
    };
  }

  toLight(): any {
    const db_obj = super.toLight();
    return {
      ...db_obj,
      type: this.type,
      category: this.category,
    };
  }

  copy(copyMe: TemplateBase, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.type = copyMe.type;
    this.category = copyMe.category;
    this.item = copyMe.item;
  }

  clone(drop_ids = false): TemplateBase {
    const new_obj = new TemplateBase();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copyObj(copyMe: any): void {
    this.name = copyMe.name;
    this.description = copyMe.description;
    this.item = copyMe;
    if (copyMe.toDBObj) {
      this.item = copyMe.toDBObj();
    }
  }
}